<template>
  <v-card
    elevation="0"
    class="card ma-0 pa-0 d-flex justify-center align-center"
    style="min-height:350px; max-width:350px"
    :outlined="false"
  >
    <ImageMedia v-if="hasMediaObject" class="imageMedia" :src="mediaObject" />
    <div v-else class="d-flex flex-column justify-center align-center">
      <v-icon class="ml-2 blue-grey--text text--darken-3" size="50">
        mdi-image-outline
      </v-icon>
      <span class="caption blue-grey--text text--darken-3 mt-4">
        {{ $t('common.no_image') }}
      </span>
    </div>
  </v-card>
</template>

<script>
import ImageMedia from '@/components/ImageMedia/ImageMedia.vue'
import _ from 'lodash'

export default {
  name: 'RoutinePrintImageMedia',

  components: {
    ImageMedia,
  },

  props: {
    mediaObject: {
      type: Object,
      required: true,
    },
  },

  computed: {
    hasMediaObject() {
      return !_.isEmpty(this.mediaObject)
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  border: 1px dotted $color-blue-grey-darken3;
}
.imageMedia {
  height: 350px;
  max-width: 350px;
  object-fit: fill;
}
</style>
